export default "__VITE_ASSET__2tbGQ0fe__"